import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomBoard from "../../components/CustomBoard";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as authSelector from "../../../common/selectors/auth";
import * as authAction from "../../../common/actions/auth";
import CustomToast from "../../components/CustomToast";
import LoadingOverlay from "../../components/LoadingOverlay";
import AuthManager from "../../../utils/AuthManager";

class SingpassRedirectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      height: 0,
      customToastStatus: false,
      toastMessage: "",
      registrationAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    const Id = params.get("id");
    const { getSingPass } = this.props;
    var authState = this.getUrlVars()["authState"];
    var authCode = this.getUrlVars()["authCode"];
    getSingPass(authState, authCode);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const {
      getSingPassLoading,
      getSingPassStatus,
      getSingPassData,
    } = this.props;
    if (
      getSingPassLoading === false &&
      getSingPassStatus === true &&
      getSingPassData !== null
    ) {
      const errorMsg = authSelector.getSingPassDataErrorMsg(getSingPassData);
      const token = authSelector.getSingPassDataToken(getSingPassData);
      const needSetUserID = authSelector.getSingPassDataNeedSetUserID(getSingPassData);
      const isMasterAccount = authSelector.getSingPassDataIsMasterAccount(getSingPassData);
      const sessionExpiryWarning = authSelector.getSingPassDataSessionExpiryWarning(getSingPassData);
      const sessionExpiryEnd = authSelector.getSingPassDataSessionExpiryEnd(getSingPassData);
      const isDirectClient = authSelector.getSingPassDataDirectClient(
        getSingPassData
      );
      const sessionId = authSelector.getSingPassDataSessionId(
        getSingPassData
      );
      if (errorMsg === ("" || null)) {
        AuthManager.setToken(token);
        AuthManager.setSetChangeUserID(needSetUserID);
        AuthManager.setIsMasterAccount(isMasterAccount);
        //AuthManager.setDirectClient("true");
        AuthManager.setDirectClient(isDirectClient);
        AuthManager.setSessionID(sessionId);
        AuthManager.setExpiryWarning(sessionExpiryWarning);
        AuthManager.setExpiryEnd(sessionExpiryEnd);
        window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
      } else {
        //sessionStorage.setItem("singpassError",errorMsg)
        alert("Invalid login. Please register for an account if you have not done so.");
        window.location.href = process.env.REACT_APP_LOGIN_BASE_URL;
      }
    }
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeNRIC = (event) => {
  
    this.setState({ nric: event.target.value });
  };

  onClickNext = () => {};

  onClickContactUs = () => {};

  onClickBack = () => {
    window.history.back();
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  render() {
    const { classes, registrationReqLoading } = this.props;
    const { height, nric } = this.state;
    return <div>Redirecting ...</div>;
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
});

function mapStateToProps(state) {
  return {
    getSingPassLoading: selector.getSingPassLoading(state),
    getSingPassData: selector.getSingPassData(state),
    getSingPassStatus: selector.getSingPassStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSingPass: (authState, authCode) =>
      dispatch(authAction.getSingPass(authState, authCode)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(SingpassRedirectPage)));
